export const CHILD_PRICE_RATIO = 0.75;
export const INFANT_PRICE_RATIO = 0.25;
export const DEFAULT_ADMIN_FEE = 20;

export const WEEKDAYS = [
  { day: "Mon", full: "Monday" },
  { day: "Tue", full: "Tuesday" },
  { day: "Wed", full: "Wednesday" },
  { day: "Thu", full: "Thursday" },
  { day: "Fri", full: "Friday" },
  { day: "Sat", full: "Saturday" },
  { day: "Sun", full: "Sunday" },
];

export const initialRateState = {
  adult: { basePrice: "", adminFee: "" },
  child: { basePrice: "", adminFee: "" },
  infant: { basePrice: "", adminFee: "" },
};

export const emptyPaxRow = () => ({ basePrice: "", adminFee: "" });
